import React, { useState } from 'react';
import axiosInstance from '../../axiosConfig';
import './Master.css'; // Updated import

const EditDeleteControls = ({
  messageId,
  isReply,
  originalTitle,
  originalContent,
  onEdit,
  onDelete,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editContent, setEditContent] = useState(originalContent);
  const [editTitle, setEditTitle] = useState(originalTitle || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEdit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const endpoint = isReply
      ? `/messageboard/replies/${messageId}/`
      : `/messageboard/messages/${messageId}/`;

    const payload = { content: editContent };
    if (!isReply) payload.title = editTitle;

    try {
      const response = await axiosInstance.put(endpoint, payload);
      onEdit(messageId, response.data.title || null, response.data.content);
      setIsEditing(false);
    } catch (error) {
      console.error('Error editing:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this?')) {
      const endpoint = isReply
        ? `/messageboard/replies/${messageId}/`
        : `/messageboard/messages/${messageId}/`;

      try {
        await axiosInstance.delete(endpoint);
        onDelete(messageId);
      } catch (error) {
        console.error('Error deleting:', error);
      }
    }
  };

  return (
    <div className="edit-delete-controls">
      {isEditing ? (
        <form onSubmit={handleEdit} className="nested-reply-form">
          {!isReply && (
            <input
              type="text"
              value={editTitle}
              onChange={(e) => setEditTitle(e.target.value)}
              placeholder="Edit title"
              style={{ marginBottom: '12px' }}
              required
            />
          )}
          <textarea
            value={editContent}
            onChange={(e) => setEditContent(e.target.value)}
            placeholder="Edit content"
            className="nested-reply-textarea"
            required
          />
          <div className="nested-reply-actions">
            <button type="button" onClick={() => setIsEditing(false)} className="cancel-reply-btn">
              Cancel
            </button>
            <button type="submit" disabled={isSubmitting} className="submit-reply-btn">
              {isSubmitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      ) : (
        <>
          <button onClick={() => setIsEditing(true)}>Edit</button>
          <button onClick={handleDelete}>Delete</button>
        </>
      )}
    </div>
  );
};

export default EditDeleteControls;